const indexKintoneView = (id, userInfo, dataView) => {
    let kintoneView = '';
    kintoneView = userInfo.url_kintone + '/k/';
    const pathParts = [dataView.app_id, '?view='];

    if (dataView.workspace_type === 2) {
        pathParts.unshift('guest', dataView.workspace_uid);
    }

    if (id) {
        window.open(kintoneView + pathParts.join('/') + id, '_blank');
    } else {
        window.open(kintoneView + pathParts.join('/') + '20', '_blank');
    }
};
export { indexKintoneView };
